module.exports = __webpack_public_path__ + "img/horizontal_7_5_5.9c5f9474.png";